'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_436816d0 = {"container":"Spinner_module_container__7b0b261d","rotate":"Spinner_module_rotate__7b0b261d","svg":"Spinner_module_svg__7b0b261d","loading":"Spinner_module_loading__7b0b261d","circle":"Spinner_module_circle__7b0b261d","circle-1":"Spinner_module_circle1__7b0b261d","circle-2":"Spinner_module_circle2__7b0b261d","loading-circle":"Spinner_module_loadingCircle__7b0b261d","size-16":"Spinner_module_size16__7b0b261d","size-20":"Spinner_module_size20__7b0b261d","size-24":"Spinner_module_size24__7b0b261d","size-28":"Spinner_module_size28__7b0b261d"};
require("../../../assets/cjs/components/Spinner/src/Spinner~Cd4Zj2xm.css");

exports.default = modules_436816d0;
//# sourceMappingURL=Spinner.module.less.js.map
